module.exports = __webpack_public_path__ + "static/OR6-042d3450ed9ca253e917c952f367ed13.jpg";